import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { UsertokenService } from '../usertoken.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const utService = inject(UsertokenService);
  const ut = utService.getUserToken();

  if (!utService.hasValidToken()) {
    return next(req);
  }

  const authReq = req.clone({
    setHeaders: {
      "pkvut": "" + ut
    }
  });

  return next(authReq);
};